module.exports = __webpack_public_path__ + "img/3-3-2.2e4e3666.svg";